import { mapState, mapGetters, mapActions } from 'vuex'
// import { state } from './modules/auth'

export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
  }),
  ...mapGetters('auth', ['loggedIn', 'isAdmin', 'isSubAccount']),
}

export const layoutComputed = {
  ...mapState('layout', {
    layoutType: (state) => state.layoutType,
    leftSidebarTheme: (state) => state.leftSidebarTheme,
    leftSidebarType: (state) => state.leftSidebarType,
    layoutWidth: (state) => state.layoutWidth,
    loading: (state) => state.loading,
  }),
}

export const authMethods = mapActions('auth', [
  'logIn',
  'logOut',
  'register',
  'resetPassword',
])

export const layoutMethods = mapActions('layout', [
  'changeLayoutType',
  'changeLeftSidebarTheme',
  'changeLeftSidebarType',
  'changeLayoutWidth',
])

// notification state

export const notificationComputed = {
  ...mapGetters('notification', ['allNotifications']),
}

export const notificationMethods = mapActions('notification', [
  'getNotfications',
  'addNotification',
  'removeNotifications',
])

// campaign

export const campaignComputed = {
  ...mapGetters('campaign', [
    'allCampaigns',
    'allDrafts',
    'allTrashes',
    'currentPage',
    'perPage',
    'totalPage',
    'totalRecord',
  ]),
}

export const campaignMethods = mapActions('campaign', [
  'getCampaigns',
  'createCampaign',
  'removeCampaign',
  'getDrafts',
  'getDraft',
  'createDraft',
  'updateDraft',
  'getTrashes',
  'getTemplate',
  'decryptCampaign',
  'encryptReport',
])

// tax

export const taxComputed = {
  ...mapGetters('tax', ['allTaxs']),
}

export const taxMethods = mapActions('tax', ['getTaxs'])

// phonebook

export const phonebookComputed = {
  ...mapGetters('phonebook', [
    'allContacts',
    'allGroups',
    'currentPage',
    'perPage',
    'totalPage',
    'totalRecord',
  ]),
}

export const phonebookMethods = {
  ...mapActions('phonebook', [
    'getContacts',
    'getContact',
    'createContact',
    'updateContact',
    'removeContact',
    'getGroups',
    'getGroup',
    'updateGroup',
    'createGroup',
    'removeGroup',
  ]),
}

// accounts

export const accountComputed = {
  ...mapGetters('account', ['allAccounts']),
}

export const accountMethods = {
  ...mapActions('account', [
    'getAccounts',
    'createAccount',
    'removeAccount',
    'toggleAccountStatus',
  ]),
}

// profile account

export const profileComputed = {
  ...mapGetters('profile', ['profileDetail']),
}

export const profileMethods = mapActions('profile', [
  'getProfile',
  'updateProfile',
])

// group state

export const groupComputed = {
  ...mapGetters('group', [
    'allGroups',
    'currentPage',
    'perPage',
    'totalPage',
    'totalRecord',
  ]),
}

export const groupMethods = mapActions('group', [
  'getGroups',
  'updateGroup',
  'createGroup',
  'removeGroup',
  'addNotification',
])

// Sender ID

export const senderIdComputed = {
  ...mapGetters('senderId', [
    'allSenderIds',
    'currentPage',
    'perPage',
    'totalPage',
    'totalRecord',
  ]),
}

export const senderIdMethods = {
  ...mapActions('senderId', [
    'getSenderIds',
    'createSenderId',
    'approveSenderId',
    'removeSenderId',
    'updateSenderId',
    'defaultSenderId',
  ]),
}

// Topup
export const topupComputed = {
  ...mapGetters('topup', ['topupHistories', 'allRates']),
}

export const topupMethods = {
  ...mapActions('topup', ['getTopups', 'getRates']),
}

// Traffi

export const trafficComputed = {
  ...mapGetters('traffic', ['allTraffics']),
}

export const trafficMethods = {
  ...mapActions('traffic', ['getTraffics']),
}

// Billings

export const billingComputed = {
  ...mapGetters('billing', ['allBillings']),
}

export const billingMethods = {
  ...mapActions('billing', ['getBillings']),
}

// system configuration

export const configComputed = {
  ...mapGetters('configuration', [
    'allErrors',
    'allRoutes',
    'allCountries',
    'countryPaginate',
    'allOperators',
    'operatorPaginate',
    'allMcoses',
    'allErrorMaps',
    'allSenderGroups',
    'allSenderCriterias',
    'allGlobalSettings',
    'currentPage',
    'perPage',
    'totalPage',
    'totalRecord',
  ]),
}

export const configMethods = {
  ...mapActions('configuration', [
    'getErrors',
    'getRoutes',
    'getCountries',
    'removeCountry',
    'getOperators',
    'getMcoses',
    'getErrorMaps',
    'getSenderGroups',
    'getSenderCriterias',
    'getGlobalSettings',
  ]),
}

// Administrator

export const administratorComputed = {
  ...mapGetters('administrator', [
    'allSystemUsers',
    'reportColumn',
    'allGroupAccesses',
  ]),
}

export const administratorMethods = {
  ...mapActions('administrator', [
    'getSystemUsers',
    'getReportColumn',
    'toggleReportColumn',
    'getGroupAccesses',
  ]),
}

// Monitor

export const monitorComputed = {
  ...mapGetters('monitor', ['allCarrierSmppAcounts']),
}

export const monitorMethods = {
  ...mapActions('monitor', ['getCarrierSmppAccounts']),
}
